<template><div></div></template>

<script setup lang="ts">
import { onMounted, watch } from "vue";
import { useUserStore } from "@/stores/user";
import axios from "axios";

const userStore = useUserStore();

const logout = () => {
  userStore.setToken("");
  window.location.href = `${process.env.VUE_APP_FRONTEGG_BASE_URL}/oauth/logout?post_logout_redirect_uri=${process.env.VUE_APP_BASE_URL}`;
};

const switchToExpert = () => {
  userStore.setToken("");
  window.open(process.env.VUE_APP_EXPERT_APP_BASE_URL, "_self");
};

const createExpertAndSwitch = () => {
  const cloneAsExpertUrl = process.env.VUE_APP_CLONE_AS_EXPERT_URL;
  const headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${userStore.token}`,
      UserType: "company_user",
    },
  };

  axios
    .post(cloneAsExpertUrl, {}, headers)
    .then((response) => {
      switchToExpert();
    })
    .catch((error) => {
      console.log(error);
    });
};

const switchProfile = () => {
  if (userStore.token) {
    if (userStore.switchable) {
      switchToExpert();
    } else {
      createExpertAndSwitch();
    }
  } else {
    logout();
  }
};

onMounted(() => {
  if (userStore.token) {
    switchProfile();
  }
});

watch(
  () => userStore.token,
  (newToken) => {
    if (newToken) {
      switchProfile();
    }
  }
);
</script>
